module.exports = {
  "wxc-overlay": {
    "width": "750",
    "position": "fixed",
    "top": 0,
    "bottom": 0,
    "right": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-440361d4!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-overlay/index.vue
// module id = 173
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34